"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FRQWithId;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _reactUseIdHook = require("react-use-id-hook");
var _CompletedContext = require("../CompletedContext");
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));
var DEBUG = false;
var TaskFreeResponse = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskFreeResponse, _Component);
  var _super = (0, _createSuper2.default)(TaskFreeResponse);
  function TaskFreeResponse(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskFreeResponse);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      var _this$props$completed;
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = (_this$props$completed = _this.props.completed) !== null && _this$props$completed !== void 0 ? _this$props$completed : false;
      _this.state.value = "";
      _this.state.errors = [];
      _this.state.errorState = {};
    }
    return _this;
  }
  (0, _createClass2.default)(TaskFreeResponse, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevprops.completed !== this.props.completed) {
        this.setState({
          completed: this.props.completed
        });
      }
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "collectElts",
    value: function collectElts(elts) {
      var arr = [];
      var curr = '';
      var _iterator = (0, _createForOfIteratorHelper2.default)(elts),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var x = _step.value;
          if (typeof x !== 'string') {
            if (curr.length > 0) arr.push(curr);
            arr.push(x);
          } else {
            curr += ' ' + x;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (curr.length > 0) arr.push(curr);
      return arr;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$validator,
        _this$props$noValueEr,
        _this3 = this,
        _this$props$value;
      var validators = [].concat((0, _toConsumableArray2.default)((_this$props$validator = this.props.validators) !== null && _this$props$validator !== void 0 ? _this$props$validator : []), [{
        test: function test(value, validity, state) {
          var r = value.length > 0 || validity.badInput;
          if (state) {
            state.empty = !r;
          }
          return r;
        },
        message: (_this$props$noValueEr = this.props.noValueError) !== null && _this$props$noValueEr !== void 0 ? _this$props$noValueEr : "Write something in the field to proceed."
      }]);
      if (this.props.type === "number") {
        validators.push({
          test: function test(value, validity, state) {
            var r = !isNaN(Number.parseInt(value)) || !validity.badInput;
            if (state) {
              state.nan = !r;
            }
            return r;
          },
          message: "Please enter a number."
        });
      }
      if (this.props.min !== undefined && this.props.max !== undefined) {
        validators.push({
          test: function test(value, validity, state) {
            var r = Number(value) >= _this3.props.min && Number(value) <= _this3.props.max || isNaN(Number.parseInt(value));
            if (state) {
              state.outOfRange = !r;
            }
            return r;
          },
          message: "Please select a value that is no less than ".concat(this.props.min, " and no greater than ").concat(this.props.max, ".")
        });
      } else {
        if (this.props.min !== undefined) {
          validators.push({
            test: function test(value, validity, state) {
              var r = Number(value) >= _this3.props.min || isNaN(Number.parseInt(value));
              if (state) {
                state.outOfRange = !r;
              }
              return r;
            },
            message: "Please select a value that is no less than ".concat(this.props.min, ".")
          });
        }
        if (this.props.max !== undefined) {
          validators.push({
            test: function test(value, validity, state) {
              var r = Number(value) <= _this3.props.max || isNaN(Number.parseInt(value));
              if (state) {
                state.outOfRange = !r;
              }
              return r;
            },
            message: "Please select a value that is no greater than ".concat(this.props.max, ".")
          });
        }
      }
      if (this.props.minCharacters !== undefined) {
        validators.push({
          test: function test(value, validity, state) {
            var r = value.length >= _this3.props.minCharacters;
            if (state) {
              state.notEnoughCharacters = !r;
            }
            return r;
          },
          message: "Please enter at least ".concat(this.props.minCharacters, " characters to continue.")
        });
      }
      if (this.props.maxCharacters !== undefined) {
        validators.push({
          test: function test(value, validity, state) {
            var r = value.length <= _this3.props.maxCharacters;
            if (state) {
              state.tooManyCharacters = !r;
            }
            return r;
          },
          message: "Please enter less than ".concat(this.props.maxCharacters, " characters to continue.")
        });
      }
      if (this.props.minWords !== undefined) {
        validators.push({
          test: function test(value, validity, state) {
            var r = value.split(" ").length >= _this3.props.minWords;
            if (state) {
              state.notEnoughWords = !r;
            }
            return r;
          },
          message: "Please enter at least ".concat(this.props.minWords, " words to continue.")
        });
      }
      if (this.props.maxWords !== undefined) {
        validators.push({
          test: function test(value, validity, state) {
            var r = value.split(" ").length <= _this3.props.maxWords;
            if (state) {
              state.tooManyWords = !r;
            }
            return r;
          },
          message: "Please enter less than ".concat(this.props.maxWords, " words to continue.")
        });
      }
      var onSubmit = function onSubmit(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        var input = _this3.props.multiline ? document.querySelector("#".concat(_this3.props.id, " textarea")) : document.querySelector("#".concat(_this3.props.id, " input"));
        var value = (_this3.props.value || _this3.state.value).toString();
        var messages = [];
        var errorState = {};
        if (messages.length === 0) {
          var _iterator2 = (0, _createForOfIteratorHelper2.default)(validators),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _step2.value,
                test = _step2$value.test,
                message = _step2$value.message,
                strTest = _step2$value.strTest;
              if (strTest) {
                test = new Function("value", "validator", strTest);
              }
              var result = test(value, input.validity, errorState, _this3.state.value);
              if (!result) {
                messages.push(message);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        DEBUG && console.log("onSubmit", value, messages, errorState, input.validity);
        if (messages.length === 0) {
          _this3.setState({
            completed: true,
            valid: true,
            errors: messages,
            errorState: errorState
          });
        } else {
          _this3.setState({
            showFeedback: !_this3.props.noSubmit,
            errors: messages,
            completed: false,
            errorState: errorState
          });
        }
      };
      var elts = [this.props.feedbackInsufficient].concat((0, _toConsumableArray2.default)(this.collectElts(this.state.errors)));
      var errors = [];
      var _iterator3 = (0, _createForOfIteratorHelper2.default)(elts),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var elt = _step3.value;
          errors.push(elt);
          errors.push(" ");
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (this.props.feedbackOverrideNoValue) {
        if (this.state.errorState.empty) {
          errors = [this.props.feedbackOverrideNoValue];
        }
      }
      if (this.props.feedbackOverrideBadInput) {
        if (this.state.errorState.nan) {
          errors = [this.props.feedbackOverrideBadInput];
        }
      }
      if (this.props.feedbackOverrideOutOfRange) {
        if (this.state.errorState.outOfRange) {
          errors = [this.props.feedbackOverrideOutOfRange];
        }
      }
      return /*#__PURE__*/_react.default.createElement("form", {
        style: this.props.style,
        key: this.props.key,
        id: this.props.id,
        className: "task task-free-response",
        onSubmit: onSubmit
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.TextField, {
        type: this.props.type,
        description: this.props.description,
        feedbackClass: this.props.noSubmit ? undefined : "d-none",
        invalidClass: this.props.noSubmit ? undefined : " ",
        validators: this.props.noSubmit ? validators : undefined,
        validateOnChange: this.props.noSubmit || false,
        onChange: function onChange(e) {
          DEBUG && console.log("onChange");
          if (_this3.props.onChange) {
            _this3.props.onChange(e);
            if (_this3.props.noSubmit) {
              window.setTimeout(function () {
                onSubmit();
              }, 0);
            }
          }
          _this3.setState({
            value: e.target.value
          }, function () {
            if (_this3.props.noSubmit) {
              onSubmit();
            }
          });
        },
        value: (_this$props$value = this.props.value) !== null && _this$props$value !== void 0 ? _this$props$value : this.state.value,
        disabled: this.props.noSubmit ? false : this.state.completed,
        multiline: this.props.multiline,
        style: this.props.style
      }, this.props.label), !this.props.noSubmit && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginBottom: "30px"
        }
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        variant: "solid",
        disabled: this.state.completed,
        style: {
          float: "right"
        },
        onClick: onSubmit
      }, "Submit")), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showFeedback,
        onHide: function onHide() {
          return _this3.setState({
            showFeedback: false
          });
        }
      }, errors));
    }
  }]);
  return TaskFreeResponse;
}(_react.Component);
TaskFreeResponse.contextType = _CompletedContext.CompletedContext;
function FRQWithId(props) {
  var id = (0, _reactUseIdHook.useId)();
  return /*#__PURE__*/_react.default.createElement(TaskFreeResponse, Object.assign({
    id: id
  }, props));
}